/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */


import {Version} from '@angular/core';
/**
 * \@stable
 */
export const VERSION = new Version('4.4.3');



// WEBPACK FOOTER //
// ../../../../packages/router/src/version.ts